<template>
	<NP-Modal class="select-cash-machine-modal" :toggle="toggle" :label="'Вiдскануйте ШК робочого місця та оберіть РРО'">
		<form @submit.prevent="submit">
			<NP-Input
				v-model="workplaceCode"
				label="ШК робочого місця"
				:error="workplaceError"
				:has-error="Boolean(workplaceError)"
				:disabled="loadingActions.includes('findWorkplace') || showCashMachineOtpInput"
				ref="workplaceCode"
			/>
			<NP-Select
				v-if="!use_thermal_printer"
				id="cash_machine"
				label="Номер РРО"
				v-model="cashMachine"
				:options="cashMachineOptions"
				:async-options="_lookupCashMachines"
				do-empty-search-on-init
				:disabled="showCashMachineOtpInput"
				searchable
			/>
			<NP-Input
				v-if="use_thermal_printer"
				v-model="printerTestNumber"
				label="Контрольний номер принтера"
				:error="printerError"
				:has-error="Boolean(printerError)"
				ref="printerTestNumber"
			/>
			<NP-Input
				v-if="showCashMachineOtpInput"
				v-model="cashMachineOtp"
				label="Контрольний номер зі стрічки РРО"
				ref="cashMachineOtp"
			/>
			<NP-Checkbox v-if="showThermalPrinterCheckbox" name="use_thermal_printer" v-model="use_thermal_printer">
				Відкрити зміну з використанням термопринтера
			</NP-Checkbox>
			<div class="buttons">
				<NP-Button type="button" class="cancel-btn" @click="toggle">
					<i slot="icon" class="icon-close" />
					Скасувати
				</NP-Button>
				<NP-Button
					type="submit"
					priority="high"
					class="confirm-btn"
					:disabled="
						(!use_thermal_printer && !cashMachine) || !workplaceCode || (showCashMachineOtpInput && !cashMachineOtp)
					"
					:loading="loadingActions.includes('openCashdesk-1') || loadingActions.includes('generateCashMachineCode')"
				>
					Зберегти
				</NP-Button>
			</div>
		</form>
	</NP-Modal>
</template>

<script>
import { http } from 'novapay-ui';
import find from 'lodash/find';

import log from '@services/log';
import thermalPrinter from '@services/thermal-printer';

export default {
	name: 'SelectCashMachineModal',
	props: {
		showCashMachineOtpInput: { type: Boolean, default: false },
		generateCashMachineCode: { type: Function, default: null },
		toggle: { type: Function, default: null },
		openCashdesk: { type: Function, default: null },
		lookupCashMachines: { type: Function, default: null },
		loadingActions: { type: Array, default: () => [] },
		root: { type: Object, default: null }
	},
	data() {
		return {
			use_thermal_printer: false,
			cashMachine: null,
			cashMachineOptions: [],
			workplaceCode: '',
			cashMachineOtp: '',
			printerTestNumber: null,
			workplaceError: null,
			printerError: null
		};
	},
	computed: {
		showThermalPrinterCheckbox() {
			return (
				thermalPrinter.connected &&
				(['10313', '14019', '04303', '10531'].includes(this.root.salepoint.code) ||
					this.root.salepoint.branch === 'Філія № 4 (Львівська обл.)')
			);
		}
	},
	mounted() {
		this.$refs.workplaceCode.$refs.input.focus();
	},
	methods: {
		_lookupCashMachines(query) {
			return this.lookupCashMachines({
				query,
				cb: (res) => {
					this.cashMachineOptions = res.data;
				}
			});
		},
		submit() {
			let data = {
				loadingAction: { id: 1 }
			};

			if (this.use_thermal_printer) {
				this.printerError = null;
				if (!thermalPrinter.checkTestNumber(this.printerTestNumber)) {
					this.printerError = 'Контрольний номер введено невірно';
					return;
				}
				data = {
					...data,
					use_thermal_printer: true
				};
			} else {
				if (!this.cashMachine) {
					return;
				}
				data = {
					...data,
					cash_machine_id: this.cashMachine.id
				};
			}

			this.workplaceError = null;
			let { workplaceCode: workplace_id } = this;
			workplace_id = (workplace_id || '').trim();
			if (
				!workplace_id ||
				!workplace_id.startsWith('433') ||
				!/^[0-9-]+$/.test(workplace_id) ||
				workplace_id.length < 5 ||
				workplace_id.length > 11
			) {
				this.workplaceError = 'ШК введено невiрно';
				return;
			}
			if (!this.use_thermal_printer && !this.cashMachineOtp) {
				return this.generateCashMachineCode({ code: this.cashMachine.code, loadingAction: true });
			}
			workplace_id = workplace_id.replace(/\D/g, '').substr(3);
			data = {
				...data,
				workplace_id,
				entered_code: this.cashMachineOtp
			};

			return this.openCashdesk(data);
		}
	},
	watch: {
		async cashMachineOptions(val) {
			if (!val || !val.length) {
				return;
			}
			let connectedCashMachine = await http('http://localhost:8001/GetRROData');
			if (connectedCashMachine && connectedCashMachine.data && connectedCashMachine.data.SerialNumber) {
				this.cashMachine = find(val, { code: connectedCashMachine.data.SerialNumber });
				log('rro-data', connectedCashMachine.data);
			}
		},
		async use_thermal_printer(val) {
			if (!val) {
				return;
			}
			await thermalPrinter.printTestNumber();
			this.$refs.printerTestNumber.$refs.input.focus();
		},
		showCashMachineOtpInput(val) {
			if (!val) {
				this.cashMachineOtp = '';
			} else {
				setTimeout(() => this.$refs.cashMachineOtp.$refs.input.focus());
			}
		}
	}
};
</script>

<style lang="scss">
@import '@assets/scss/variables.scss';
@import '@assets/scss/mixins.scss';
$icon-close: '~@assets/images/icon-close.svg';
.select-cash-machine-modal {
	.modal-container {
		width: 490px;
		overflow-y: visible !important;
	}
	.input,
	.np-select,
	.checkbox {
		margin-bottom: 16px;
	}
	.buttons {
		display: flex;
		justify-content: space-between;
		margin-top: 16px;
		.icon-close {
			@include make-icon($icon-close, $gray-40, 20px, 20px);
		}
	}
}
</style>
